module.exports = __webpack_public_path__ + "static/media/peacock_dancing-min.9bd1b92c.gif";